import Annotation from 'components/Annotation'
import { AnnotationTextMarker as TM } from 'components/Annotation/AnnotationTextMarker'
import { CircleAnnotation } from 'components/Annotation/CircleAnnotation'

const isMobile = window.innerWidth < 712

export const bern_data: CityData = {
  name: 'Bern',
  bfsid: '351',
  sat_images: [
    {
      label: 'Tiefer Status - Tscharnergut in Bümpliz',
      image: isMobile
        ? require('../../../Content/Maps/maps_351_sat_poor_mob.jpg')
        : require('../../../Content/Maps/maps_351_sat_poor.jpg'),
    },
    {
      label: 'Hoher Status - Kirchenfeld',
      image: isMobile
        ? require('../../../Content/Maps/maps_351_sat_rich_mob.jpg')
        : require('../../../Content/Maps/maps_351_sat_rich.jpg'),
    },
  ],
  elements: [
    {
      id: 'all',
      text: (
        <>
          <p>
            Bern wirkt relativ homogen, fast auf dem gesamten Stadtgebiet leben
            ausschliesslich gut situierte Menschen – insbesondere zentrumsnah.
            Die weniger privilegierten Einwohnerinnen und Einwohner verteilen
            sich auf einige Flecken in den Quartieren{' '}
            <TM prio={4}>Lorraine, Breitenrain und Matte</TM>, dem früheren
            Unterschichtenviertel. Oder aber sie leben an den Rändern der Stadt.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 15 : 30}
              angle={isMobile ? 190 : 133}
            >
              Matte
            </CircleAnnotation>
          ),
          position: { x: 72, y: 53 },
          position_mobile: { x: 74, y: 50.5 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 30 : 60}
              angle={isMobile ? 200 : 10}
            >
              Lorraine/Breitenrain
            </CircleAnnotation>
          ),
          position: { x: 67, y: 40 },
          position_mobile: { x: 73, y: 35 },
        },

        {
          content: <Annotation priority={3}>Kirchenfeld</Annotation>,
          position: { x: 68, y: 65 },
          position_mobile: { x: 70, y: 60 },
        },

        {
          content: <Annotation priority={3}>Bümpliz</Annotation>,
          position: { x: 8, y: 68 },
          position_mobile: { x: 10, y: 63 },
        },
        {
          content: <Annotation priority={3}>Bethlehem</Annotation>,
          position: { x: 8, y: 48 },
          position_mobile: { x: 10, y: 45 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_351_all_mob.jpg')
        : require('../../../Content/Maps/maps_351_all.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_351_all_mob_dm.jpg')
        : require('../../../Content/Maps/maps_351_all_dm.jpg'),
    },
    {
      id: 'rich',
      text: (
        <>
          <p>
            Eine Ballung von Menschen mit einem hohen Status gibt es in der
            Innenstadt und im Süden – so im wohlhabenden Quartier{' '}
            <TM prio={2}>Kirchenfeld.</TM> Vor dessen Überbauung gegen Ende des
            19. Jahrhunderts liess das zuständige Baukomitee verlauten, man
            wolle ein Viertel für die «habliche» Bevölkerung schaffen.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation size={isMobile ? 35 : 40} angle={75}>
              Kirchenfeld
            </CircleAnnotation>
          ),
          position: { x: 68, y: 61 },
          position_mobile: { x: 74, y: 56 },
        },
        // {
        //   content: <Annotation priority={3}>Matte</Annotation>,
        //   // position: { x: 70, y: 60 },
        //   // position_mobile: { x: 50, y: 50 },
        // },

        {
          content: <Annotation priority={3}>Lorraine/Breitenrain</Annotation>,
          position: { x: 72, y: 41 },
          position_mobile: { x: 60, y: 35 },
        },

        {
          content: <Annotation priority={3}>Bümpliz</Annotation>,
          position: { x: 8, y: 68 },
          position_mobile: { x: 10, y: 63 },
        },
        {
          content: <Annotation priority={3}>Bethlehem</Annotation>,
          position: { x: 8, y: 48 },
          position_mobile: { x: 10, y: 45 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_351_rich_mob.jpg')
        : require('../../../Content/Maps/maps_351_rich.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_351_rich_mob_dm.jpg')
        : require('../../../Content/Maps/maps_351_rich_dm.jpg'),
    },
    {
      id: 'poor',
      text: (
        <>
          <p>
            Viele ärmere Stadtbernerinnen und Stadtberner leben in{' '}
            <TM prio={3}>Bümpliz,</TM> einem früheren Bauerndorf, das 1919
            eingemeindet wurde. Hier, zum Beispiel im Quartier{' '}
            <TM prio={3}>Bethlehem,</TM> stehen Berns Wohnsilos, die zuweilen
            als DDR-Plattenbauten und Ausländerghettos verspottet werden.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation size={isMobile ? 45 : 70} angle={45}>
              Bümpliz
            </CircleAnnotation>
          ),
          position: { x: 18, y: 66 },
          position_mobile: { x: 16, y: 59 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 30 : 50}
              angle={isMobile ? 310 : 260}
            >
              Bethlehem
            </CircleAnnotation>
          ),
          position: { x: 18, y: 50 },
          position_mobile: { x: 15, y: 48 },
        },
        // {
        //   content: <Annotation priority={3}>Matte</Annotation>,
        //   position: { x: 70, y: 60 },
        // },
        {
          content: <Annotation priority={3}>Kirchenfeld</Annotation>,
          position: { x: 68, y: 65 },
          position_mobile: { x: 70, y: 60 },
        },
        {
          content: <Annotation priority={3}>Lorraine/Breitenrain</Annotation>,
          position: { x: 72, y: 41 },
          position_mobile: { x: 60, y: 35 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_351_poor_mob.jpg')
        : require('../../../Content/Maps/maps_351_poor.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_351_poor_mob_dm.jpg')
        : require('../../../Content/Maps/maps_351_poor_dm.jpg'),
    },
  ],
}
